import {DocumentMetadata} from '../../entity/model/document-metadata';
import {makeAutoObservable} from 'mobx';
import {RequestBody} from '../../entity/core/request-body';
import {MetadataAgent} from '../agent/metadata-agent';
import {DocumentMetadataUpdateResponse} from '../../entity/dto/marketplace-excel-metadata-update-dto';

export default class MetadataStore {
  metadataAgent: MetadataAgent;

  constructor(metadataAgent: MetadataAgent) {
    makeAutoObservable(this)
    this.metadataAgent = metadataAgent;
  }

  getPendingMetadataList = async (requestBody: RequestBody): Promise<DocumentMetadata[] | string> => {
    try {
      return await this.metadataAgent.getPendingMetadataList(requestBody);
    } catch (error) {
      return 'Error occurred while get metadata. Please try again in while !!';
    }
  }

  updateDocumentMetadata = async (requestBody: RequestBody): Promise<DocumentMetadataUpdateResponse | string> => {
    try {
      return await this.metadataAgent.updateDocumentMetadata(requestBody);
    } catch (error) {
      return 'Error occurred while updating document metadata. Please try again in while !!';
    }
  }
}
